import React from "react";
import { useTranslation } from "react-i18next";
import TabsNavigator from "components/TabsNavigator";
import PageShell from "components/bento/PageShell";
import PackagesTab from "./PackagesTab";
import PaymentsTab from "./PaymentsTab";

// Photo Gallery — read-only browse of every photo on the system, split into
// albums. Tab slugs map to role permissions (see shared/pageSlugs.json).
const Gallery = () => {
  const { t } = useTranslation();
  const tabItems = [
    { text: t("gallery.tabPackages"), component: <PackagesTab />, slug: "gallery/packages" },
    { text: t("gallery.tabPayments"), component: <PaymentsTab />, slug: "gallery/payments" },
  ];

  return (
    <PageShell title={t("gallery.title")} subtitle={t("gallery.subtitle")}>
      <TabsNavigator tabItems={tabItems} pageSlug="gallery" />
    </PageShell>
  );
};

export default Gallery;
